export const version = 'v2.2.4-2241-gafb4e179a'
